import _classCallCheck from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
export var Point = function Point(position, particle) {
  _classCallCheck(this, Point);

  this.position = position;
  this.particle = particle;
};